/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Min_ScoreInputs */

const en_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min Score:`)
};

const de_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestpunktzahl:`)
};

const fr_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score minimum :`)
};

const es_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación mínima:`)
};

const it_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio min:`)
};

const nl_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. score:`)
};

const pl_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. wynik:`)
};

const fi_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vähimmäispistemäärä:`)
};

const da_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Min. score:`)
};

const sv_jobs_min_score = /** @type {(inputs: Jobs_Min_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minpoäng:`)
};

/**
* | output |
* | --- |
* | "Min Score:" |
*
* @param {Jobs_Min_ScoreInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_min_score = /** @type {((inputs?: Jobs_Min_ScoreInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Min_ScoreInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_min_score(inputs)
	if (locale === "fr") return fr_jobs_min_score(inputs)
	if (locale === "es") return es_jobs_min_score(inputs)
	if (locale === "it") return it_jobs_min_score(inputs)
	if (locale === "nl") return nl_jobs_min_score(inputs)
	if (locale === "pl") return pl_jobs_min_score(inputs)
	if (locale === "fi") return fi_jobs_min_score(inputs)
	if (locale === "da") return da_jobs_min_score(inputs)
	if (locale === "sv") return sv_jobs_min_score(inputs)
	return en_jobs_min_score(inputs)
});